<template>
<div class="RelayLog">
    <div class="title-container">
        <div class="search-area">
            <SelectTime v-model='searchTime' @change="pageChange(1)"/>
            <el-button type="primary" @click="pageChange(1)" class="ml-10">{{$t(/*搜索*/'c.search')}}</el-button>
        </div>
    </div>
    <div class="table-container">
        <el-table :data="tableData" v-loading="loading" :row-class-name="tableRowClass">
            <el-table-column width="160" :label="$t(/*创建时间*/'c.create_time')">
                <template slot-scope="{row}">{{$U.timeFormat(row.create_time)}}</template>
            </el-table-column>
            <el-table-column width="160" :label="$t(/*请求时间*/'command.request_time')">
                <template slot-scope="{row}">{{$U.timeFormat(row.request_time / 1000)}}</template>
            </el-table-column>
            <el-table-column width="160" :label="$t(/*类型*/'c.type')">
                <template slot-scope="{row}">{{$t($U.requestDataType(row))}}</template>
            </el-table-column>
            <el-table-column min-width="160" :label="$t(/*请求数据*/'command.request_data')">
                <template slot-scope="{row}">
                    <el-button type="text" @click="handleDialogShow(row.request_data)">{{row.request_data}}</el-button>
                </template>
            </el-table-column>
            <el-table-column width="100" :label="$t(/*推送地址*/'command.notify_url')">
                <template slot-scope="{row}">
                    <el-popover placement="top-start" trigger="hover" :content="row.url">
                        <span slot="reference">{{$t(/*查看*/'c.view')}}</span>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column width="160" :label="$t(/*响应时间*/'command.response_time')">
                <template slot-scope="{row}">{{ $U.timeFormat(row.response_time / 1000) }}</template>
            </el-table-column>
            <el-table-column width="140" :label="$t(/*耗时*/'command.elapsed_time')">
                <template slot-scope="{row}">{{ $U.relayLogExecutionTime(row) }}</template>
            </el-table-column>
            <el-table-column  min-width="160" :label="$t(/*响应时间*/'command.response_data')">
                <template slot-scope="{row}">
                    <el-button type="text" @click="handleDialogShow(row.response_data)">{{ row.response_data }}</el-button>
                </template>
            </el-table-column>
            <el-table-column width="220" label="MUID" prop='muid'/>
            <el-table-column width="100" :label="$t(/*推送次数*/'command.retry_count')" prop='retry_count'/>
        </el-table>
    </div>
    <div class="paging-container with-btn">
        <el-button @click="pageChange(1)">{{$t(/*刷新*/'c.refresh')}}</el-button>
        <el-pagination
            @current-change="pageChange"
            :current-page="currPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <el-dialog title="推送数据" :visible.sync="dialogVisible" custom-class="json-dialog" width="600px">
        <div class="content">
            <div class="pre-warp"><pre>{{jsonData}}</pre></div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Core from '../../../core'

export default {
    components: {
        SelectTime: () => import('@/components/common/SelectTime.vue'),
    },
    props: {
        uid: { type: [String] },
        id:  { type: [String, Number] },
        space: { type: [String, Number] },
        detail: { type: Object, default: () => {}},
    },
    data() {
        return {
            loading: false,

            searchTime: {},

            tableData: [],
            currPage: 1,
            pageSize: 10,
            total: 0,

            dialogVisible: false,
            jsonData: '',
        }
    },
    mounted() {
        this.pageChange(1)
    },
    methods: {
        getTableData() {
            if (!this.uid) { return }
            this.loading = true;

            Core.Api.Device.relayLog({
                page: this.currPage,
                space: this.space,
                device_uid: this.uid,
                ...this.searchTime
            }).then(res => {
                this.tableData = res.relay_log_list;
                this.total = res.count;
            }).finally(() => {
                this.loading = false
            })
        },
        pageChange(page) {
            this.currPage = page;
            this.getTableData();
        },

        handleDialogShow(data) {
            try {
                this.jsonData = JSON.stringify(JSON.parse(data), null, 2);
            } catch (error) {
                this.jsonData = ''
            }
            this.dialogVisible = true;
        },

        tableRowClass({row}) {
            if (row.retry_count > 0) {
                return 'row warning';
            }
            return 'row';
        }
    },
}
</script>

<style lang='scss' scoped>
.RelayLog {
    overflow: hidden;
    .row.warning {
        /*opacity: 0.5;*/
        background: #F56C6C55;
    }
    .mg-15-1 {
        margin-top: 15px;
        margin-left: 15px;
    }
}
</style>